import React from 'react';

export default function HubTabs({ tabs, active, onChange }) {
  return (
    <div className="vi-tabs-wrap" dir="rtl">
      <div className="vi-tabs" role="tablist">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active === t.id}
            className={active === t.id ? 'vi-tab vi-tab--active' : 'vi-tab'}
            onClick={() => onChange(t.id)}
          >
            {t.icon && <span aria-hidden>{t.icon}</span>}
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}